// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>13</span>&nbsp;&nbsp;The Lord looks down from heaven&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;and beholds all the children of earth.<br> </p> </div></div>";
// Exports
module.exports = code;